import { styled } from '@mui/material';
import Box from '@mui/material/Box';
import Typography, { TypographyProps } from '@mui/material/Typography';

export const GridContainer = styled(Box)(({ theme }) => ({
  backgroundColor: theme.brandV2.colors.treadGray8,
  display: 'grid',
  gridTemplateColumns: '1fr',
  gridTemplateRows: 'auto auto 1fr',
  height: 'calc(100vh - 65px - var(--tread-agent-dock-height, 0px))',
  margin: theme.spacing(0, -5),
}));

export const GridRow = styled(Box)(({ theme }) => ({
  backgroundColor: theme.semantic.surfaceRaised,
  borderTop: `solid 1px ${theme.palette.divider}`,
  padding: theme.spacing(1, 6),
}));

export const FlexColumn = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(0.5),
}));

export const FlexRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(0.5),
}));

export const Card = styled(Box)(({ theme }) => ({
  // In dark mode the card sits a step above the page on the elevation ramp
  // (surfaceOverlay vs the surface base) so it reads as clearly raised — a plain
  // drop shadow barely registers on the near-black base. Light keeps the shipped
  // white raised surface + drop shadow. Mirrors ~components/OrderCard/OrderCard.
  backgroundColor:
    theme.palette.mode === 'dark'
      ? theme.semantic.surfaceOverlay
      : theme.semantic.surfaceRaised,
  border: `solid 1px ${theme.brandV2.colors.treadGray7}`,
  borderRadius: theme.spacing(),
  boxShadow:
    theme.palette.mode === 'dark'
      ? 'inset 0 1px 0 0 rgba(255, 255, 255, 0.06), 0 2px 8px 0 rgba(0, 0, 0, 0.55)'
      : '0px 1px 3px 0px rgba(0, 0, 0, 0.20)',
  display: 'flex',
  width: '100%',
}));

const StyledLabel = styled(Typography)(({ theme }) => ({
  color: theme.brandV2.colors.treadGray1,
  fontSize: 'inherit',
  fontWeight: 600,
}));
export const Label = StyledLabel.withComponent('span');

const StyledValue = styled(Typography)<TypographyProps>(() => ({
  fontSize: 'inherit',
  fontWeight: 400,
}));
export const Value = StyledValue.withComponent('span');
